/**
 * 年龄段显示文案。
 *
 * 放在视图层而不是 `@spirit/contracts`：契约冻结的是 `AgeBand` 的**取值**
 * （'0-3' 这类机器可读的字符串），不是它的显示文案。把中文放进契约，
 * 会让后端为了改一个"岁"字而发版；而且同一个取值在别的端可能显示成 "0–3 yrs"。
 *
 * 放在独立文件而不是某个 SFC 里：`<script setup>` 不允许具名导出，
 * 而 DomainBadge / AgeBandBadge（渲染用）和 AgeBandPicker（选择用）都要读它。
 */

import type { AgeBand } from '@spirit/contracts';

export const AGE_BAND_LABELS: Readonly<Record<AgeBand, string>> = Object.freeze({
  '0-3': '0-3 岁',
  '4-6': '4-6 岁',
  '7-12': '7-12 岁',
  '13-18': '13-18 岁',
});
